import { IAssignment } from "./assignment.model";

export class LocationAssignment implements IAssignment{
    id: string; 
    startDate: number;
    endDate: number;
    startTime: string;
    endTime: string;
    locationId: string;
    locationName: string;
    taskAssignmentId: string;
    timeAtLocation: number;
    toggle: boolean;
}